import { animate, state, style, transition, trigger } from '@angular/animations';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getImageSrc } from '../../../core/images';

export interface QueryParams {
  account_filters: string;
  marketId: string;
}

interface CTAButton {
  text: string;
  url: string;
  queryParams?: QueryParams;
  feature?: string;
}

export interface CourseParams {
  text?: string;
  url?: string;
  logo?: string;
}

export interface LinkParams {
  icon?: string;
  text?: string;
  url?: string;
}

@Component({
  selector: 'app-home-page-card-footer',
  styleUrls: ['home-page-card-footer.component.scss'],
  templateUrl: './home-page-card-footer.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('collapsed <=> expanded', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class HomePageCardFooterComponent {
  getImageSrc = getImageSrc;
  isMobile$: Observable<boolean>;
  showLessText$: Observable<string>;
  showMoreText$: Observable<string>;

  @Input() cardContext: string;
  @Input() ctaButtons: CTAButton[];
  @Input() linkParams?: LinkParams;
  @Input() courseParams?: CourseParams;

  @Input() learnMoreExpanded = false;

  constructor(private readonly router: Router, private readonly breakpointObserver: BreakpointObserver) {
    this.isMobile$ = this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(map((result) => result.matches));

    this.showLessText$ = this.isMobile$.pipe(
      map((resp) => {
        if (resp) {
          return 'COMMON.ACTION_LABELS.LESS';
        }
        return 'COMMON.ACTION_LABELS.SHOW_LESS';
      }),
    );

    this.showMoreText$ = this.isMobile$.pipe(
      map((resp) => {
        if (resp) {
          return 'COMMON.ACTION_LABELS.MORE';
        }
        return 'COMMON.ACTION_LABELS.LEARN_MORE';
      }),
    );
  }

  handleLearnMoreToggleClicked = (): void => {
    this.learnMoreExpanded = !this.learnMoreExpanded;
  };

  linkClicked(linkUrl: string): void {
    window.open(linkUrl, '_blank');
  }

  buttonClicked(cta: CTAButton): void {
    this.router.navigate([cta.url], { queryParams: cta.queryParams });
  }
}
